import {eq} from '@shared/helpers/lang'

import {ReasonTypeInfoMap, ReasonTypeType, OrderEntry, OrderSheetPageSet, EntryType} from '@web/core/constants'
import {
    sendOrderApplyFailToNelo,
    sendOrderFailToNelo,
    sendOrderFailureToNelo,
    sendOrderInitToNelo,
    sendOrderTryToNelo,
    sendLeaveToNelo,
} from '@web/helpers/nelo'
import {actionLoggerCreator} from '@web/middlewares/logger'

import type {RootState} from '../../interfaces'

const getSaleChannelGroup = (saleChannelType: Maybe<EntryType>) => {
    const eqSaleChannelType = eq(saleChannelType)
    if (eqSaleChannelType(OrderEntry.CHECKOUT)) {
        return OrderSheetPageSet.MALL
    }
    if (
        eqSaleChannelType(OrderEntry.EASY_BOOKING) ||
        eqSaleChannelType(OrderEntry.LOCAL_PAY) ||
        eqSaleChannelType(OrderEntry.NAVER_BLOG)
    ) {
        return OrderSheetPageSet.EASYBOOKING
    }
    return null
}

const loggerMiddleware = actionLoggerCreator<RootState>({
    callbackLeaveAction: ({state, action, path, type}) => {
        sendLeaveToNelo({
            entry: state.common.entry,
            pageSet: getSaleChannelGroup(state.common.entry),
            orderSheetId: state.common.seqID,
            message: action.type,
            type,
            path,
        })
    },
    callbackLogAction: ({state, log}) => {
        if (log.type === 'failure') {
            const {code, message} = log.info
            sendOrderFailureToNelo({
                entry: state.common.entry,
                orderSheetId: state.common.seqID,
                pageSet: getSaleChannelGroup(state.common.entry),
                code,
                message,
            })
        } else if (log.type === 'info') {
            const {message} = log.info
            sendOrderInitToNelo({
                entry: state.common.entry,
                pageSet: getSaleChannelGroup(state.common.entry),
                message,
            })
        } else if (log.type === 'orderTry') {
            const {code} = log.info
            sendOrderTryToNelo({
                entry: state.common.entry,
                code,
                orderSheetId: state.common.seqID,
                pageSet: getSaleChannelGroup(state.common.entry),
            })
        } else if (log.type === 'orderFail') {
            const {orderProcessId, orderNo, code, message} = log.info
            sendOrderFailToNelo({
                entry: state.common.entry,
                orderNo,
                orderProcessId,
                code,
                message,
                orderSheetId: state.common.seqID,
                pageSet: getSaleChannelGroup(state.common.entry),
                level: ReasonTypeInfoMap[code as ReasonTypeType]?.level ?? 'ERROR',
            })
        } else if (log.type === 'orderApplyFail') {
            const {orderNo, orderSheetId, orderProcessId, code, message, pageSet} = log.info
            sendOrderApplyFailToNelo({
                entry: state.common.entry,
                orderNo,
                orderSheetId,
                orderProcessId,
                code,
                message,
                pageSet,
                level: code ? (ReasonTypeInfoMap[code as ReasonTypeType]?.level ?? 'ERROR') : 'ERROR',
            })
        }
    },
})

export default loggerMiddleware
